const intro = {

	elem: {
		intro: document.querySelectorAll('.intro'),
	},

	init() {
		if(intro.elem.intro.length > 0) {
			intro.elem.intro.forEach(function(element) {
				element.addEventListener('mouseenter', intro.expand);
			});
		}
	},

	// expand(): when someone mouses over the intro component, add a class which expands it to full screen width
	expand(event) {
		event.target.classList.add('intro--expanded');
	}
};

export { intro };
